import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { AuthStore } from '../store/auth.store';

/**
 * Guard que protege las páginas de extracción (transferencia interna, pago de
 * servicios, etc.). Cuando el KYC es obligatorio (política total o "después de
 * la primera extracción") y el customer no está verificado, informa, redirige a
 * /settings/kyc y bloquea el acceso; en la primera operación (KYC opcional)
 * puede mostrar el diálogo "Realizar KYC / Más tarde" y deja pasar si el
 * usuario pospone. Reutiliza AuthStore.ensureKycApprovedForExtraction (async)
 * para compartir mensaje, diálogo y redirección con las acciones de extracción.
 */
export const kycApprovedForExtractionGuard: CanActivateFn = () => {
  return inject(AuthStore).ensureKycApprovedForExtraction();
};
